
    <ng-container></ng-container>
  


// WEBPACK FOOTER //
// ./src/compat/compat-abtest.component.ts.CompatABTestComponent.html